import { Link } from "react-router-dom";
import type { BreadcrumbItem } from "@/core/navigation/breadcrumb-trail";

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  if (items.length <= 1) return null;

  return (
    <nav className="ph-breadcrumb" aria-label="Fil d'Ariane">
      <ol className="ph-breadcrumb-list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="ph-breadcrumb-item">
              {isLast || !item.to ? (
                <span className="ph-breadcrumb-current" aria-current={isLast ? "page" : undefined}>
                  {item.label}
                </span>
              ) : (
                <Link to={item.to} className="ph-breadcrumb-link">
                  {item.label}
                </Link>
              )}
              {!isLast && (
                <span className="ph-breadcrumb-sep" aria-hidden>
                  ›
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
